import React from 'react';
import PhoneNumberInput, {isValidPhoneNumber} from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';

// EU + UK; GG/JE/IM share +44 and some UK numbers resolve to them
const COUNTRIES: any[] = [
    'CY', 'AT', 'BE', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'GG', 'JE', 'IM',
];

type Props = {
    value?: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    disabled?: boolean;
    className?: string;
    placeholder?: string;
};

// The library expects E.164; old values may contain spaces or dashes ("+357-99-123456").
const toE164 = (value?: string) => value ? '+' + value.replace(/\D/g, '') : undefined;

const PhoneInput = ({value, onChange, onBlur, disabled, className, placeholder = 'phone number'}: Props) => (
    <PhoneNumberInput
        international
        flags={flags} // bundled SVGs instead of the library's default external CDN
        defaultCountry="CY"
        countries={COUNTRIES}
        value={toE164(value)}
        onChange={(v) => onChange(v || '')}
        onBlur={onBlur}
        disabled={disabled}
        // field styles go on the wrapper so the flag sits inside the box; the inner input is reset in App.scss
        className={`PhoneField ${className || ''}`}
        placeholder={placeholder}
    />
);

export const isValidPhone = (value?: string) => !!value && isValidPhoneNumber(value);

export default PhoneInput;
